var _path, _path2, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 15.6143C32.38 15.0943 31.54 15.0943 31.02 15.6143L24.5 22.1209L17.98 15.6009C17.46 15.0809 16.62 15.0809 16.1 15.6009C15.58 16.1209 15.58 16.9609 16.1 17.4809L22.62 24.0009L16.1 30.5209C15.58 31.0409 15.58 31.8809 16.1 32.4009C16.62 32.9209 17.46 32.9209 17.98 32.4009L24.5 25.8809L31.02 32.4009C31.54 32.9209 32.38 32.9209 32.9 32.4009C33.42 31.8809 33.42 31.0409 32.9 30.5209L26.38 24.0009L32.9 17.4809C33.4066 16.9743 33.4066 16.1209 32.9 15.6143Z",
    fill: "#D8907D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9 15.6143C32.38 15.0943 31.54 15.0943 31.02 15.6143L24.5 22.1209L17.98 15.6009C17.46 15.0809 16.62 15.0809 16.1 15.6009C15.58 16.1209 15.58 16.9609 16.1 17.4809L22.62 24.0009L16.1 30.5209C15.58 31.0409 15.58 31.8809 16.1 32.4009C16.62 32.9209 17.46 32.9209 17.98 32.4009L24.5 25.8809L31.02 32.4009C31.54 32.9209 32.38 32.9209 32.9 32.4009C33.42 31.8809 33.42 31.0409 32.9 30.5209L26.38 24.0009L32.9 17.4809C33.4066 16.9743 33.4066 16.1209 32.9 15.6143Z",
    fill: "url(#paint0_linear_7070_118863)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "#D8907D",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "url(#paint1_linear_7070_118863)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7070_118863",
    x1: 15.9192,
    y1: 13.746,
    x2: 32.8696,
    y2: 14.0184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8907D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7070_118863",
    x1: 1.07143,
    y1: -3.99995,
    x2: 47.3523,
    y2: -3.25615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8907D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose3);
export default __webpack_public_path__ + "static/media/close-3.c55e15f712be4b9e0696d46f277b14d8.svg";
export { ForwardRef as ReactComponent };